import React, { useState, useEffect } from 'react'
import useManageWeeklyShip from './useManageWeeklyShip';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { toast } from 'react-toastify';

const WeeklyShipBoxInsert = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [highestIndex, setHighestIndex] = useState(0);
  const [shipDate, setShipDate] = useState('');
  const [localBoxes, setLocalBoxes] = useState([]); // Local copy to avoid race condition
  const [boxNo, setBoxNo] = useState('')
  const [history, setHistory] = useState([]);
  const [editingItem, setEditingItem] = useState(null); // Track when editing a history item
  const [isUnpack, setIsUnpack] = useState(false); // Assign boxNo to unpacked-contents photos, not box photos
  const {boxUrl, getUnmatchBoxUrl, getUnmatchUnpackBoxUrl, addBoxNo} = useManageWeeklyShip()

  // A box row carries shipImageUrl (box photo) or unpackImageUrl (unpack mode).
  const imgOf = (b) => b?.shipImageUrl || b?.unpackImageUrl;

  // Sync localBoxes when boxUrl changes from API
  useEffect(() => {
    if (boxUrl && boxUrl.length > 0) {
      setLocalBoxes(boxUrl);
      setCurrentIndex(0);
      setHighestIndex(0);
    }
  }, [boxUrl]);

  const onEnter = async () => {
    // Validate input before clearing
    if(boxNo === '' || boxNo.trim() === ''){
      console.log("Please Enter Number")
      return;
    }

    const boxNoValue = boxNo.trim();

    // Check if we're editing a history item
    if (editingItem) {
      setBoxNo(''); // Clear input after validation
      
      const payload = {
        id: editingItem.id,
        boxNo: boxNoValue,
        shipDate: shipDate,
        ...(isUnpack && { type: 'unpack' }),
      };

      const response = await addBoxNo(payload)
      if(response === true){
        toast.success("แก้ไขสำเร็จ - Box No: " + boxNoValue)
        
        // Update the history item with new boxNo
        setHistory(prevHistory => prevHistory.map(item => 
          item.id === editingItem.id ? { ...item, boxNo: boxNoValue } : item
        ));
        
        // Exit edit mode
        setEditingItem(null);
      }else{
        toast.error('แก้ไขไม่สำเร็จ ติดต่อพี่เกน')
        setBoxNo(boxNoValue);
      }
      return;
    }

    // Normal flow - adding new box
    const currentBox = localBoxes[currentIndex];
    if (!currentBox) {
      console.log("No box available")
      return;
    }

    setBoxNo(''); // Clear input after validation

    const existingIndex = history.findIndex(item => item.id === currentBox?.id);
    console.log(currentBox)
    if (existingIndex !== -1) {
      // Update existing item in history
      setHistory(prevHistory => prevHistory.map((item, index) => 
        index === existingIndex ? { ...item, boxNo: boxNoValue } : item
      ));
    } else {
      // Add new item to history with full box data
      setHistory([
        ...history, 
        {
          id: currentBox.id,
          boxNo: boxNoValue,
          image: imgOf(currentBox)
        }
      ]);
    }

    const payload = {
      id: currentBox.id,
      boxNo: boxNoValue,
      shipDate: shipDate,
      ...(isUnpack && { type: 'unpack' }),
    };

    const response = await addBoxNo(payload)
    if(response === true){
      toast.success("SUCCESS")
      
      // Remove matched item from local state immediately (no race condition)
      // The item at currentIndex is removed, next item slides into position
      setLocalBoxes(prev => prev.filter((_, idx) => idx !== currentIndex));
      // Keep currentIndex at 0 since items shift down
      setCurrentIndex(0);
    }else{
      toast.error('เพิ่มเลขกล่องไม่สำเร็จ ติดต่อพี่เกน')
      // Restore the boxNo if update failed
      setBoxNo(boxNoValue);
    }
  }



  const handleKeyPress = (event) => {
    if(event.key === 'Enter') {
      onEnter()
    }
  }

  const handleButtonClick = () => {
    onEnter()
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    // Allow only positive numbers
    if (/^[0-9]*$/.test(value)) {
      setBoxNo(value);
    }
  }

  const handleHistoryClick = (historyItem) => {
    // Set the editing item and pre-fill the boxNo
    setEditingItem(historyItem);
    setBoxNo(historyItem.boxNo || '');
    console.log('Editing:', historyItem)
  };

  const cancelEdit = () => {
    setEditingItem(null);
    setBoxNo('');
  };

  const handleSelectChange = async (e) => {
    const newShipDate = e.target.value;
    setShipDate(newShipDate)
    // Reset state before loading new data
    setHistory([]);
    setBoxNo('');
    setEditingItem(null); // Clear edit mode
    // This will trigger the useEffect to update localBoxes
    await (isUnpack ? getUnmatchUnpackBoxUrl : getUnmatchBoxUrl)(newShipDate)
  }

  const handleUnpackToggle = async (e) => {
    const checked = e.target.checked;
    setIsUnpack(checked);
    // Reload the current round's queue from the matching source (ship vs unpack photos).
    setHistory([]);
    setBoxNo('');
    setEditingItem(null);
    if (shipDate) {
      await (checked ? getUnmatchUnpackBoxUrl : getUnmatchBoxUrl)(shipDate);
    }
  }

  useEffect(() => {
    if (localBoxes.length > 0 && currentIndex + 1 < localBoxes.length) {
      const nextImage = new Image();
      nextImage.src = imgOf(localBoxes[currentIndex + 1]);
      nextImage.onload = () => {
        console.log('Next image preloaded!');
        // Optionally set a state variable here to indicate that the image is loaded
      };
    }
  }, [currentIndex, localBoxes]);

  useEffect(() => {
    if(currentIndex > highestIndex){
      setHighestIndex(currentIndex)
    }
  }, [currentIndex])

  // Determine what to show in main image area
  const displayImage = editingItem ? editingItem.image : imgOf(localBoxes[currentIndex]);
  const displayId = editingItem ? editingItem.id : localBoxes[currentIndex]?.id;

  return (
    <div className='h-screen grid grid-cols-3 gap-x-10'>
      <div className='col-span-2'>
        <ShipDateDropdown
          handleDataChange={handleSelectChange}
          includeDefault={true}
          />
          <label className='flex items-center gap-2 my-2 select-none'>
            <input type="checkbox" checked={isUnpack} onChange={handleUnpackToggle} />
            <span>โหมดรูปแกะกล่อง (unpack)</span>
          </label>
          {editingItem && (
            <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-2 mb-2">
              <span className="font-bold">กำลังแก้ไข Box No: {editingItem.boxNo}</span>
            </div>
          )}
          {displayImage ?
            <img 
              key={displayId} 
              className="h-4/5" 
              src={displayImage} 
              alt="current" 
            />
            : <p className='h-4/5 text-5xl py-10'>No more Image</p>
          }
        {/* <label>{currentIndex}</label> */}
        <input 
          className='input-form my-2 text-4xl'
          name="boxNo"
          type="text" 
          value={boxNo} 
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          autoFocus
        />
        <div className="flex gap-2">
          <button className='btn btn-blue text-2xl' onClick={handleButtonClick}>
            {editingItem ? 'Update' : 'Save'}
          </button>
          {editingItem && (
            <button className='btn btn-red text-2xl' onClick={cancelEdit}>
              Cancel
            </button>
          )}
        </div>
      </div>
      <div className="border-gray-400 border-l">
      <span className='ml-4 text-5xl pb-4'>Previous Box No</span>
        {history.slice(-3).map((item, index) => (
          <div 
            key={item.id || index} 
            className={`flex py-4 border-b border-gray-400 pl-4 cursor-pointer hover:bg-gray-100 ${editingItem?.id === item.id ? 'bg-yellow-50 border-l-4 border-yellow-500' : ''}`}
            onClick={() => handleHistoryClick(item)}
          >
            <img className="h-64" src={item.image} alt={`history-item-${index}`} />
            <span className='ml-4 text-5xl'>{item.boxNo}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WeeklyShipBoxInsert